import { createApp } from 'vue'
import App from './App.vue'
import { createI18n } from 'vue-i18n'

import translations from './i18n.json'

const urlParams = new URLSearchParams(window.location.search);

const i18n = createI18n({
  locale: urlParams.get('lang') == 'es' ? 'es' : 'en',
  messages: translations
})


createApp(App)
  .use(i18n)
  .mount('#app')

